export default __webpack_public_path__ + "c6c5d67b7715948d5d3e408c5216430a.png";